import type { RouteRecordRaw } from 'vue-router'

export const productsRoutes: RouteRecordRaw[] = [
  {
    path: '/products',
    name: 'products',
    component: () => import('./views/ProductsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
]
